import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink, Play } from 'lucide-react';

const CaseStudies = () => {
  const caseStudies = [
    {
      id: 1,
      title: "Case Study 1",
      description: "Real retirement planning scenario from Rate My Retirement",
      videoUrl: "https://youtu.be/5uZ0EZfNzig?si=gQk0DFqDa1iicDi2",
      thumbnail: "https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750784239412_197afc8a.png"
    },
    {
      id: 2,
      title: "Case Study 2",
      description: "Live streaming retirement analysis and recommendations",
      videoUrl: "https://youtu.be/FcSiBwZKU3M?si=F-nj5XwgK6YVjgne",
      thumbnail: "https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750784239412_197afc8a.png"
    },
    {
      id: 3,
      title: "Case Study 3",
      description: "Interactive retirement planning session",
      videoUrl: "https://youtu.be/-6ae1kphopk?si=eLXj6qx19fMs3GYr",
      thumbnail: "https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750784239412_197afc8a.png"
    },
    {
      id: 4,
      title: "Case Study 4",
      description: "Comprehensive retirement strategy review",
      videoUrl: "https://youtu.be/WoHOwlfe95I?si=D6ALQ-0U6lYVfHyT",
      thumbnail: "https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750784239412_197afc8a.png"
    }
  ];

  const handleThumbnailClick = (videoUrl: string) => {
    window.open(videoUrl, '_blank');
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Case Studies from Rate My Retirement
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Watch real retirement planning scenarios from our live streaming show where we analyze and provide recommendations for actual retirement situations.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {caseStudies.map((study) => (
            <Card key={study.id} className="group hover:shadow-lg transition-shadow">
              <CardHeader className="p-0">
                <div 
                  className="relative aspect-video bg-gray-200 rounded-t-lg overflow-hidden cursor-pointer"
                  onClick={() => handleThumbnailClick(study.videoUrl)}
                >
                  <img 
                    src={study.thumbnail} 
                    alt={study.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Play className="w-12 h-12 text-white" />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-4">
                <CardTitle className="text-lg mb-2">{study.title}</CardTitle>
                <CardDescription className="text-sm mb-4">
                  {study.description}
                </CardDescription>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full"
                  onClick={() => window.open(study.videoUrl, '_blank')}
                >
                  Watch on YouTube
                  <ExternalLink className="w-4 h-4 ml-2" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;